import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SsoMetadataRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.SsoMetadata', {
		url: '/sso/metadata/:code',
		controllerAs: 'vm',
		controller: SsoMetadataCtrl,
		templateUrl: '/ng/hub/Sso/Metadata/SsoMetadataCtrl.html?' + window.BUILD,
		permission: [],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Sso/Metadata/SsoMetadataCtrl.css'),
			$title: () => 'Public SSO Metadata',
			metadata: ApiResourcify.endpoint('/sso/sps/:code/metadata', {
				headers: { Authorization: 'Public' },
			}),
		},
	});
}

export class SsoMetadataCtrl {
	constructor(metadata) {
		'ngInject';
		this.metadata = metadata;
		this.domains = metadata.domains.join('\n');
		this.xmlUri = 'data:text/xml;base64,' + btoa(this.metadata.xml);
		this.crtUri = 'data:application/x-509-user-cert;base64,' + btoa(this.metadata.cert.raw);
	}
}
